import React from 'react';
import { Outlet } from 'react-router-dom';

import ErrorBoundary from 'components/ErrorBoundary';
import SetupPageAcme from 'containers/SetupPageAcme';
import { useGetStartedTrigger } from 'containers/SetupPageAcme';
import Mixpanel from 'utils/mixpanel';

const LayoutDatasets = () => {
  useGetStartedTrigger();

  return (
    <>
      <SetupPageAcme />

      <ErrorBoundary>
        <Mixpanel />
      </ErrorBoundary>

      <Outlet />
    </>
  );
};
export default LayoutDatasets;
